import commonFunction from "../../lib/utils/common";

import Header1 from "./theme1";
import Header2 from "./theme2";
import Header4 from "./theme4";
import Header5 from "./theme5";
import Header7 from "./theme7";
import Header8 from "./theme8";
import Header9 from "./theme9";
import Header10 from "./theme10";
import Header11 from "./theme11";
import Header12 from "./theme12";
import Header13 from "./theme13";


export function Header(props) {
  const { theme } = props;


  switch (theme) {
    case "theme1":
      return (
        !commonFunction.isValueEmpty(props) &&
        Object.keys(props).length > 0 && <Header1 data={props} />
      );
      break;
    case "theme2":
      return (
        !commonFunction.isValueEmpty(props) &&
        Object.keys(props).length > 0 && <Header2 data={props} />
      );
      break;
    case "theme4":
      return (
        !commonFunction.isValueEmpty(props) &&
        Object.keys(props).length > 0 && <Header4 data={props} />
      );
      break;
    case "theme5":
      return (
        !commonFunction.isValueEmpty(props) &&
        Object.keys(props).length > 0 && <Header5 data={props} />
      );
      break;
    case "theme7":
      return (
        !commonFunction.isValueEmpty(props) &&
        Object.keys(props).length > 0 && <Header7 data={props} />
      );
    case "theme8":
      return (
        !commonFunction.isValueEmpty(props) &&
        Object.keys(props).length > 0 && <Header8 data={props} />
      );
      break;
    case "theme9":
      return <Header9 data={props} />;
      break;
    case "theme10":
      return <Header10 data={props} />;
      break;
    case "theme11":
      return <Header11 data={props} />;
      break;
    case "theme12":
      return <Header12 data={props} />;
      break;
    case "theme13":
      return (
        !commonFunction.isValueEmpty(props) &&
        Object.keys(props).length > 0 && <Header13 data={props} />
      );
      break;
    default:
      return <Header1 data={props} />;
  }
}

export default Header;
